export default __webpack_public_path__ + "static/media/SELECT_NEXT_CONTAINER.d104ba17.svg";